import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { FormGroup, FormControl, ControlLabel/*, HelpBlock*/, Col, Clearfix } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Redirect, Link } from 'react-router-dom';
import { actionCreators } from '../../store/LoginActionsReducers';

class Login extends Component {
    displayName = Login.name;
    constructor(props) {
        super(props);

        this.state = {
            redirectToForgotPassword: false
        };
    }

    onSubmit = async (e) => {
        e.preventDefault();
        let username = document.getElementsByName('username')[0].value;
        let password = document.getElementsByName('password')[0].value;
        await this.props.requestLoginToken(username, password);
    }

    onClickForgotPassword = (e) => {
        e.preventDefault();
        this.setState({ redirectToForgotPassword: true });
    }

    render() {
        if (this.props.isAuthenticated) {
            return (
                <Redirect to="/" />
            );
        }
        else if (this.state.redirectToForgotPassword) {
            return (
                <Redirect to="/ForgotPassword" />
            );
        }
        else {
            return (
                <div>
                    <Col xs={10} xsOffset={1} sm={8} smOffset={2} md={6} mdOffset={3} lg={6} lgOffset={3} >
                        <div style={{ paddingBottom: '25px' }}>
                            <img width="300" height="119" src="/pulse-by-ivet360-300x119.png" className="attachment-medium center-block" alt="Pulse by iVET360 - Log in" srcSet="/pulse-by-ivet360-300x119.png 300w, /pulse-by-ivet360.png 756w" sizes="(max-width: 300px) 100vw, 300px" />

                            <form onSubmit={this.onSubmit} style={{ maxWidth: '25em', margin: 'auto' }}>
                                <FormGroup controlId="formControlsUsername">
                                    <ControlLabel>Email</ControlLabel>
                                    <FormControl componentClass="input" type="text" name="username" placeholder="Email" />
                                </FormGroup>
                                <FormGroup controlId="formControlsPassword">
                                    <ControlLabel>Password</ControlLabel>
                                    <FormControl componentClass="input" type="password" name="password" placeholder="Password" />
                                    <div>
                                        <label style={{ paddingTop: '8px', fontSize: '11px' }} className="pull-right">
                                            <Link to="#" onClick={this.onClickForgotPassword} className="plain-link">Forgot Password?</Link>
                                        </label>
                                    </div>
                                </FormGroup>
                                <Clearfix />
                                <br />
                                <FormGroup className="text-center">
                                    <button className="btn-block" type="submit" style={{ margin: '0' }} >SIGN IN</button>
                                </FormGroup>
                            </form>
                        </div>
                    </Col>
                </div>
            );
        }
    }
}

export default connect(
    state => state.login,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(Login);




// WEBPACK FOOTER //
// ./src/components/Login/Login.js